import React from "react";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import "./privacyPolicy.css";
import ProgressBarLoader from "../../components/ProgressBarLoader/ProgressBarLoader";

const PrivacyPolicy = () => {
  return (
    <div>
      <ProgressBarLoader />
      <Breadcrumbs title="Política de Privacidad" pagename="Política de Privacidad" />
      <div className="container py-5">
        <h1 className="text-center mb-5 page-title">Política de Privacidad</h1>
        <div className="privacy-content">
        El presente aviso de privacidad en lo sucesivo "EL AVISO" se emite en cumplimiento a
        lo dispuesto por el artículo 15 de la Ley Federal de Protección de Datos Personales en
        Posesión de los Particulares en lo sucesivo "LA LEY", y sus correlativos del
        Reglamento de la Ley Federal de Protección de Datos Personales en Posesión de los
        Particulares en lo sucesivo "EL REGLAMENTO", y se pone a disposición de los
        usuarios que entreguen datos o información de carácter personal a TRANSPORTES
        SALINACRUCENSES S.C DE R.L., en lo sucesivo "SALINACRUCENSES".

        1.Responsable de la protección de sus Datos Personales
        “SALINACRUCENSES”, con domicilio para recibir notificaciones en : Antonio Caso
        107, Esquina periférico, Col. Jose Vasconcelos, Oaxaca de Juárez, Oaxaca; es
        responsable, del tratamiento de sus datos personales.
        “SALINACRUCENSES” en su carácter de responsable del tratamiento de datos
        personales observa los principios de licitud, consentimiento, información, calidad,
        finalidad, lealtad, proporcionalidad y responsabilidad, tal y como lo establece "LA
        LEY".

      2.Forma y medios de contacto
      Para contactarnos, usted deberá presentar una solicitud redactada en idioma
      español, dirigida a la OFICINA DE PROTECCIÓN DE DATOS PERSONALES DE
      “SALINACRUCENSES”, y hacerla llegar de manera presencial o por correo postal a la
      dirección: Antonio Caso 107, Esquina Periferico, Col. Jose Vasconcelos, Oaxaca de
      Juarez,Oaxaca o por correo electrónico a: datos.personales@salinacrucenses.com

      3.Datos personales que recabamos y medios de obtención de Datos Personales
      Los datos personales que recabamos de los usuarios para dar cumplimiento a los
      fines descritos en el presente "AVISO", son recabados de manera directa, cuando
      usted nos los proporciona a través de nuestras taquillas, nuestra página web www.
      salinacrucenses.com, aplicaciones móviles, redes sociales oficiales, servicios de
      mensajería instantánea por internet, centros de atención, quejas y sugerencias
      denominados “hola”, de manera telefónica y por correo electrónico, y cuando
      obtenemos información a través de otras fuentes de acceso público permitidas por
      "LA LEY" y “EL REGLAMENTO”.
      Los datos que recabamos son los siguientes:
      De las personas físicas: Nombre completo y apellidos, género (masculino o
      femenino), imagen, fecha de nacimiento, nacionalidad, número de teléfono fijo,
      número de celular, correo electrónico, domicilio, credenciales o contraseñas de
      redes sociales o buscadores (cuando usted decida registrarse como usuario de
      nuestras herramientas tecnológicas mediante redes sociales o buscadores), edad e
      identificación oficial. En cuanto a los datos de carácter patrimonial, tales como el
      Registro Federal de Contribuyentes (RFC), domicilio fiscal y datos e información de
      pago, usted al hacer uso de esta información para adquirir alguno de nuestros
      productos o servicios, otorga su consentimiento expreso para el tratamiento de estos
      datos conforme a lo dispuesto en el artículo 8 de “LA LEY”.
      De las personas morales: Del representante o apoderado legal, nombre completo y
      apellidos, identificación oficial, firma, correo electrónico, clave única de registro de
      población, fecha de nacimiento, teléfono, domicilio y nacionalidad. En cuanto a los
      datos de carácter patrimonial o financiero de la empresa, como el Registro Federal de
      Contribuyentes (RFC), domicilio fiscal y datos e información de pago, el apoderado o
      representante legal, al hacer uso de esta información para adquirir alguno de
      nuestros productos o servicios, otorga su consentimiento expreso para el tratamiento
      de estos datos conforme a lo dispuesto en el artículo 8 de “LA LEY”.
      Le informamos que “SALINACRUCENSES” no almacena ninguna información de
      tarjetas de débito, crédito o método de pago como parte del procesamiento de pago.
      “SALINACRUCENSES” transmite la información de las tarjetas de débito, crédito o
      método de pago directamente con su Banco o a la plataforma de pago que esté
      utilizando.
      Asimismo, toda vez que "LA LEY" permite otras fuentes de allegarnos de información
      como lo son directorios telefónicos y de servicios, físicos o electrónicos, los datos
      que por dichos medios podemos obtener son nombre y apellidos, teléfono, correo
      electrónico y domicilio.
      
3.1. Datos Personales de terceros y menores de edad
“SALINACRUCENSES” podrá recabar y dar tratamiento a datos personales de
identificación y contacto de terceras personas, tales como su nombre completo,
correo electrónico y número telefónico, cuando usted o dichos terceros los
proporcionen para fines relacionados con los productos y/o servicios contratados en
nombre de dichos terceros, por lo que al proporcionarlos usted reconoce haber
informado a estos terceros sobre el uso de sus datos personales y haber obtenido de
forma previa el consentimiento de estos últimos para que “SALINACRUCENSES”
pueda tratarlos para los fines antes señalados.
“SALINACRUCENSES” no recaba ni trata datos personales de menores de edad, por
lo que usted reconoce que al momento de proporcionar sus datos es mayor de edad,
cuenta con plena capacidad jurídica y ha leído el presente aviso de privacidad. En el
caso de que como excepción se recaben y traten datos personales de menores de
edad o de personas con incapacidad natural o legal establecida por ley, como el
nombre y la edad, estos se recabarán o tratarán previo consentimiento de la persona
que ejerza la patria potestad, o la tutela o representación legal, de conformidad con
las leyes aplicables.
Si “SALINACRUCENSES” identifica que un menor de edad o persona con incapacidad
natural o legal ha proporcionado sus datos personales sin el consentimiento de quién
ejerce su patria potestad o de su tutor o representante legal, o que, por error humano
o técnico, se han recabado datos personales de menores de edad o de personas con
incapacidad natural o legal, dichos datos personales serán eliminados de las bases
de datos que los contengan en cuanto se tenga conocimiento de ello.
3.2.Datos personales sensibles
“SALINACRUCENSES” no recabará ni dará tratamiento a datos personales sensibles
de ninguna clase.
4.Finalidades del Tratamiento de los Datos Personales
Sus datos personales serán utilizados para las siguientes finalidades:
Finalidades Primarias: Finalidades que dieron origen y son necesarias para la
existencia, mantenimiento y cumplimiento de la relación jurídica entre usted y
“SALINACRUCENSES”:
o Identificación y contacto.
o Contratación, seguimiento, actualización, confirmación y generación de
histórico de los productos y/o servicios contratados.
o Creación, actualización, personalización, mantenimiento y autenticación de
su cuenta de usuario.
o Atención de dudas, quejas, comentarios, sugerencias, aclaraciones y
seguimiento a las mismas.
o De seguridad de las personas, al adquirir un producto o servicio, usted podría
ser videograbado o fotografiado, por lo que se le informa que las imágenes
provenientes de las videograbaciones o fotografías estarán protegidas por “LA
LEY” y “EL REGLAMENTO”, y serán conservadas en las bases de datos por un
período de diez días naturales, concluido dicho periodo las videograbaciones
o fotografías serán formateadas o eliminadas.
o Validación crediticia y de pago y evaluación del riesgo de fraude de las
transacciones.
o Facturación de los servicios o productos contratados.
o Cumplimiento de obligaciones legales y normativas, así como de
requerimientos de autoridades gubernamentales o judiciales, Federales,
Estatales o Municipales y/o entidades regulatorias.
Finalidades Secundarias: Finalidades distintas y que no dan origen a la relación
jurídica entre usted y “SALINACRUCENSES”, pero que nos son de suma utilidad para
brindarle un mejor servicio y desarrollar nuevos productos y servicios:
o Evaluación de la calidad del servicio a través de encuestas, realizar estudios
sobre hábitos de consumo y preferencias.
o Participación en concursos, sorteos, eventos y promociones. Le informamos
que, en el caso de que usted participe en dichas actividades,
“SALINACRUCENSES” podrá recabar su imagen a través de videos y/o
fotografías y publicarlas a través de distintos medios de difusión tanto físicos
como electrónicos, así como sus datos personales, tales como nombre
completo y apellidos, fecha de nacimiento, correo electrónico, dirección y
número telefónico, para en su caso documentar su participación o realizar la
entrega del premio o incentivo que corresponda.
o Informarle y/u ofrecerle la gama de productos y servicios que comercializa
“SALINACRUCENSES” y comunicarle promociones.
o Mercadotecnia y prospección comercial.
o Realizar tratamientos de técnicas de análisis masivo de datos para realizar
actividades de perfilamiento y mejor conocimiento del cliente.
La prestación de los servicios y/o la creación de una cuenta implica el
consentimiento pleno y sin reservas de los usuarios para el tratamiento de sus Datos
Personales de acuerdo con el presente Aviso de Privacidad.
En caso que usted desee manifestar OPOSICIÓN a que sus datos personales sean
tratados para las finalidades secundarias antes descritas, deberá de enviar un correo
electrónico a la dirección datos.personales@ salinacrucenses.com o presentar una
solicitud por escrito, en idioma español a la siguiente dirección: : Antonio Caso 107,
Esquina Periferico, Col. Jose Vasconcelos, Oaxaca de Juarez, Oaxaca, manifestando a
qué finalidad o finalidades secundarias se opone.
5. Limitaciones al uso de datos
Usted puede limitar el uso o divulgación de sus datos personales haciéndonos llegar
una solicitud por escrito en idioma español, dirigida a la OFICINA DE PROTECCIÓN
DE DATOS PERSONALES DE “SALINACRUCENSES”, al correo electrónico
datos.personales@salinacrucenses.com o a la siguiente dirección: : Antonio Caso
107, Esquina Periferico, Col. Jose Vasconcelos, Oaxaca de Juárez, Oaxaca, en donde
nos mencione su intención de limitar el uso o divulgación de sus datos personales e
indique datos necesarios como: nombre completo y apellidos, copia simple de su
identificación oficial, número de cliente (en caso de tener uno), número telefónico y
domicilio o correo electrónico.
Además del procedimiento contemplado en el párrafo anterior, usted podrá cancelar
su suscripción a los correos electrónicos que le enviemos con finalidades
promocionales, mercadotécnicas y/o de publicidad, dando clic a la liga que se
acompaña a cada uno de dichos correos, la cual se encuentra en la parte inferior de
los mismos.
6. Derechos ARCO
Usted o su representante legal debidamente acreditado podrán ejercer, cuando
procedan, los derechos de acceso, rectificación, cancelación u oposición en lo
sucesivo "DERECHOS ARCO" que la "LEY" prevé, mediante el mecanismo que a
continuación se describe; es importante mencionarle que el ejercicio de cualquiera
de los "DERECHOS ARCO", no impide el ejercicio de otro derecho.
6.1. Mecanismos para el ejercicio de los Derechos ARCO y la revocación del
consentimiento para el tratamiento de sus datos personales.
El ejercicio de los "DERECHOS ARCO" así como la revocación de su consentimiento
para el tratamiento de sus datos personales se realizará a través de la presentación
de la solicitud respectiva, que por escrito y en idioma español deba presentar el
titular de los datos personales o su representante legal, en atención a la OFICINA DE
PROTECCIÓN DE DATOS PERSONALES DE “SALINACRUCENSES” a la dirección
ubicada en : Antonio Caso 107, Esquina Periferico, Col. Jose Vasconcelos, Oaxaca de
Juarez, Oaxaca (los gastos de envío correrán por cuenta del solicitante), o bien al
correo electrónico datos.personales@salinacrucenses.com
Su solicitud deberá indicar nombre completo y apellidos, copia simple, legible y
vigente de su identificación oficial o en caso de utilizar medios electrónicos, deberá
adjuntar la versión digitalizada de la misma (escaneo), correo electrónico o domicilio
que designe para notificaciones y algún número telefónico de contacto. Si su
solicitud es presentada por su representante legal, deberá adicionalmente,
acompañar a su solicitud, los documentos oficiales que acrediten dicha
representación.
En caso de que la información proporcionada en su solicitud sea errónea o
insuficiente para atenderla, o bien no se acompañen los documentos de acreditación
correspondientes, se le hará un requerimiento dentro de los cinco días hábiles
siguientes a la recepción de su solicitud, para que aporte los elementos o
documentos necesarios para dar trámite a la misma. Usted contará con un plazo de
diez días hábiles para atender dicho requerimiento, contados a partir del día siguiente
en que haya sido emitido por la OFICINA DE PROTECCIÓN DE DATOS PERSONALES
DE “SALINACRUCENSES”. En caso de no dar respuesta a dicho requerimiento en el
plazo otorgado, su solicitud se tendrá por no presentada.
Cumplidos los requisitos que se señalan con anterioridad, en un plazo máximo de
veinte días hábiles contados a partir de la fecha de recepción de su solicitud de
"DERECHOS ARCO", así como de revocación del tratamiento de datos personales, la
OFICINA DE PROTECCIÓN DE DATOS PERSONALES DE “SALINACRUCENSES” dará
contestación sobre la procedencia de la misma, mediante correo electrónico dirigido
a su persona a la dirección de correo electrónico que haya indicado en la propia
solicitud, o bien enviando una notificación al domicilio que haya indicado para tales
efectos (los veinte días se darán por cumplidos al momento de entregar el
documento al servicio postal). Si la solicitud resulta procedente, está se hará efectiva
dentro de los quince días hábiles siguientes a la fecha en que se comunica la
respuesta sobre la procedencia de la misma.
7. Transferencia de datos nacional e internacional
Sus datos personales no serán transferidos nacional o internacionalmente a terceros
sin su consentimiento, salvo por lo dispuesto en el artículo 37 de "LA LEY":
o Cuando la transferencia se realice entre sociedades controladoras,
subsidiarias o afiliadas bajo el control común de “SALINACRUCENSES”, o a
una sociedad matriz o a cualquier sociedad del mismo grupo de
“SALINACRUCENSES” que opere bajo los mismos procesos y políticas
internas.
o Cuando la transferencia sea necesaria para la prevención o el diagnóstico
médico, la prestación de asistencia sanitaria, tratamiento médico o la gestión
de servicios sanitarios.
o Cuando la transferencia sea necesaria por virtud de un contrato celebrado o
por celebrar que sea en su interés, por “SALINACRUCENSES” y un tercero, con
la finalidad de otorgarle beneficios.
o Cuando la transferencia sea precisa para el mantenimiento o cumplimiento de
una relación jurídica entre “SALINACRUCENSES” y usted, tales como los
proveedores, instituciones bancarias y crediticias, cámaras de comercio, y
entre otras.
o Cuando la transferencia sea necesaria o legalmente exigida para la
salvaguarda de un interés público, o para la procuración o administración de
justicia.
8. Información en Internet
Hacemos de su conocimiento que contamos con tecnologías electrónicas (cookies y
web beacons), en nuestra página de internet: www. salinacrucenses.com, por lo que
cuando usted accede a nuestro Portal en Internet, es recibida por nuestra parte,
información referente a como es su tipo de navegador y sistema operativo, las
páginas de Internet que ha visitado recientemente, los vínculos que recientemente ha
seguido, la dirección IP de su computadora y el sitio que cerró antes de entrar a
nuestra página de internet.
Usted puede deshabilitar o ajustar el uso de estas tecnologías siguiendo los
procedimientos del navegador de internet que utiliza para acceder a nuestro sitio
web.
8.1. Exclusión de responsabilidad de nuestro sitio de internet o aplicativo
Al navegar o usar nuestro sitio de internet www. salinacrucenses.com o aplicativos,
usted podría encontrar hipervínculos, links, banners, botones, propiedad de terceros
que podrían solicitar sus datos personales (en adelante “Sitios de Terceros”). Los
datos personales que usted proporcione a través de estos portales o sitios de Internet
se sujetaran a los Avisos de Privacidad desplegados y aplicables a estos portales y
sitios de Internet, por tanto “SALINACRUCENSES” no será responsable por el uso,
publicación, revelación y/o divulgación que usted haga respecto de sus datos
personales a través de los Sitios de Terceros antes enunciados. Recomendamos a los
usuarios ser cuidadosos y responsables sobre la información de carácter personal
que proporcione en dichos sitios.
9. Conservación de datos
“SALINACRUCENSES” conservará su información durante el tiempo que la necesite
para el propósito para el que se recabo, a menos que nos solicite la eliminación de la
misma, y, en tal caso, siempre que “SALINACRUCENSES” ya no tenga la necesidad de
conservar su información por otros motivos. “SALINACRUCENSES” podrá conservar
sus datos personales por períodos más prolongados que los que requieren las leyes
aplicables, si es de nuestro interés comercial legítimo y las leyes no lo prohíben.
Tenga en cuenta que cuando hayamos recabado su información personal en función
de su consentimiento y usted retire dicho consentimiento, o ejerza sus derechos
ARCO (a suprimir su información personal), es posible que mantengamos su
información bloqueada y disponible tanto tiempo como se requiera para cumplir con
las leyes aplicables y para que “SALINACRUCENSES” cumpla con sus
responsabilidades derivadas del procesamiento de sus datos.
10. Modificaciones al presente aviso de privacidad
“SALINACRUCENSES” se reserva el derecho de efectuar en cualquier tiempo
modificaciones o actualizaciones al presente "AVISO". Las modificaciones que se
efectúen se pondrán a disposición de los usuarios a través de alguno o algunos de los
siguientes medios: anuncios visibles en nuestros taquillas o establecimientos, vía
nuestro sitio de internet www. salinacrucenses.com, aplicaciones móviles, vía correo
electrónico a la dirección más reciente que tengamos de usted, por medio de
carteles, grabaciones sonoras, de video o personalmente por medio de nuestros
encargados, al momento de acudir a cualquiera de nuestras instalaciones.
11. Definiciones
Se entiende para efectos del presente "AVISO" lo siguiente:
I. Cookies: Son los archivos de texto que se descargan automáticamente y se
almacenan en el disco duro del equipo de cómputo del usuario al navegar en una
página o portal de Internet específico, que permiten almacenar al servidor de Internet
ciertos datos, entre ellos, información sobre sus preferencias y pautas de navegación.
II. Días: Por disposición del Artículo 3° en su fracción VII de la Ley Federal de
Protección de Datos Personales en Posesión de los Particulares, los plazos y tiempos
estipulados en días, se contarán en días hábiles.
III. Derechos ARCO: Son los Derechos de Acceso, Rectificación, Cancelación y
Oposición, consagrados en "LA LEY" que por sus siglas forman dicha palabra.
IV. Ley: Ley Federal de Protección de Datos Personales en Posesión de los
Particulares, publicada en el Diario Oficial de la Federación el 5 de julio de 2010.
V. Reglamento: Reglamento de la Ley Federal de Protección de Datos Personales en
Posesión de los Particulares, publicado en el Diario Oficial de la Federación el 21 de
diciembre de 2011.
VI. Transferencia: Toda comunicación de datos personales dentro o fuera del
territorio mexicano, realizada a persona distinta del titular, del responsable o del
encargado.
VII. Web beacons: Es una imagen usada exclusivamente para cuantificar el número
de visitas o monitorear el comportamiento del usuario.
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
